import React from 'react';
import styles from "./privacy.module.scss"

function PrviacyPolicy() {
  return (
      <div className={styles.privacyContainer}>
      <h1 className={styles.heading1}>Move4wd Privacy Policy</h1>
      <div className={styles.date}>Created: October 4, 2025</div>
      
      <h2 className={styles.heading2}>Our Commitment to Your Privacy</h2>
      <p className={styles.text}>
        At Move4wd, your privacy is our priority. We use advanced security technologies, encrypted data storage, and regular backups to protect your personal information and ensure a reliable experience. Sensitive data—such as passwords, payment details, and purchase history—is encrypted and securely stored. All account data is backed up to maintain continuity and peace of mind.
      </p>
      <p className={styles.text}>
        By using Move4wd, you agree to the practices outlined in this policy.
      </p>

      <h2 className={styles.heading2}>Information We Collect</h2>
      <p className={styles.text}>
        We collect personal and shipment-related information to improve your experience and deliver personalized service. This includes:
      </p>
      <ul className={styles.list}>
        <li>Your name and contact details</li>
        <li>Vendor name and item description</li>
        <li>Item type and cost</li>
        <li>Courier and tracking number</li>
      </ul>
      <p className={styles.text}>
        This data helps us provide real-time tracking, manage customs clearance, respond to your requests, tailor communications, and analyze shipping trends.
      </p>

      <h2 className={styles.heading2}>Communications & Consent</h2>
      <p className={styles.text}>
        We may send you updates, promotions, and service notifications via email or SMS. To comply with applicable laws, you must opt in to receive SMS communications. You may opt out at any time by replying "STOP" to any text message or clicking "unsubscribe" in our emails.
      </p>
      <p className={styles.text}>
        We track engagement (such as opens and clicks) to improve our communications and ensure relevance.
      </p>

      <h2 className={styles.heading2}>Your Privacy, Protected</h2>
      <p className={styles.text}>
        Move4wd does not sell, rent, or share your personal information with third parties.
      </p>

      <h2 className={styles.heading2}>Legal Compliance</h2>
      <p className={styles.text}>
        Move4wd complies with all applicable privacy laws and regulations, including:
      </p>

      <div className={styles.lawSection}>
        <div className={styles.lawTitle}>Florida Law</div>
        <ul className={styles.list}>
          <li>
            <b>Florida Information Protection Act (FIPA):</b> Requires businesses to take reasonable measures to protect personal information and to notify individuals of data breaches.
          </li>
          <li>
            <b>Florida Telemarketing Act:</b> Governs consent and opt-out procedures for SMS and phone communications.
          </li>
        </ul>
      </div>

      <div className={styles.lawSection}>
        <div className={styles.lawTitle}>United States Federal Law</div>
        <ul className={styles.list}>
          <li>
            <b>California Consumer Privacy Act (CCPA):</b> Grants rights to access, delete, and opt out of the sale of personal data (applies to Florida businesses serving California residents).
          </li>
          <li>
            <b>CAN-SPAM Act:</b> Regulates commercial email, requiring clear opt-out options and accurate sender information.
          </li>
          <li>
            <b>Telephone Consumer Protection Act (TCPA):</b> Requires express consent for SMS marketing and provides opt-out protections.
          </li>
        </ul>
      </div>

      <h2 className={styles.heading2}>Policy Updates</h2>
      <p className={styles.text}>
        We may update this policy from time to time. Any changes will be posted on our website at the revised date.
      </p>
    </div>
  )
}

export default PrviacyPolicy